// extracted by mini-css-extract-plugin
export default {"link":"NavigationIdentity_link__T9Y5F"};